export const mimeTypes = {
    csv: '.csv',
    zip: '.zip',
    xml: '.xml',
    json: '.json',
    rar: '.rar',
    csv0: 'text/csv',
    csv1: 'application/vnd.ms-excel', //works on windows
    csv2: 'application/csv',
    csv3: 'text/x-csv',
    csv4: 'application/x-csv',
    csv5: 'text/comma-separated-values',
    csv6: 'text/x-comma-separated-values',
};

export const mediaManagerExcludedMimeTypes = [
    'application/vnd.ms-access',
    'application/msaccess',
    'application/x-debian-package',
    'application/vnd.debian.binary-package',
    'application/octet-stream',
    'application/hta',
    'application/x-internet-signup',
    'application/java-archive',
    'application/x-javascript',
    'application/x-wais-source',
    'text/scriptlet',
    'text/plain',
    'text/vbscript',
    'text/scriptlet',
    'systemdiagram/sys',
    'text/x-nsh',
    'image/x-presentations',
    'application/mgx-msp', 
    'application/tdf', 
    'image/msp',
    'application/bat',
    'application/x-bat', 
    'application/x-msdos-program' 

];

export const mediaManagerExcludedExtensions = [
    '.ade',
    '.adp',
    '.bat',
    '.chm',
    '.cmd',
    '.com',
    '.cpl',
    '.exe',
    '.hta',
    '.ins',
    '.isp',
    '.jar',
    '.js',
    '.jse',
    '.lib',
    '.lnk',
    '.mde',
    '.msc',
    '.msi',
    '.msp',
    '.mst',
    '.nsh',
    '.pif',
    '.scr',
    '.sct',
    '.shb',
    '.sys',
    '.vb',
    '.vbe',
    '.vbs',
    '.vxd',
    '.wsc',
    '.wsf',
    '.wsh',
];

export const imageMimeTypes = [
    'image/apng',
    'image/bmp',
    'image/gif',
    'image/x-icon',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/tiff',
    'image/webp',
];

export const imageWithoutScreenshotMimeTypes = [
    'image/apng',
    'image/x-icon',
    'image/webp',
];
